Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = hexToRGBA;
/* eslint no-bitwise: off */
var HEX_STRING_REGEX = /^#?[0-9a-fA-F]{6}$/;

// Convert a HEX color string to RGBA, with an optional opacity.
function hexToRGBA(hexString) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (hexString === 'transparent') {
    return hexString;
  }
  if (!HEX_STRING_REGEX.test(hexString)) {
    throw new TypeError('hexString is not valid');
  }

  var hexInt = hexString.charAt(0) === '#' ? parseInt(hexString.slice(1), 16) : parseInt(hexString, 16);

  var r = hexInt >> 16;
  var g = hexInt >> 8 & 0xFF;
  var b = hexInt & 0xFF;

  return 'rgba(' + r + ',' + g + ',' + b + ',' + String(opacity) + ')';
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/hexToRGBA.js
// module id = 444
// module chunks = 168707334958949